module.exports = __webpack_public_path__ + "img/user_YinYou.1f6c3922.png";